/* eslint-disable */
/**
 * ⚠️ FROZEN DICTIONARY — 한글 장소명 → 다국어 표기 매핑
 * ─────────────────────────────────────────────────────────
 *
 *   📌 절대 임의로 항목을 삭제하지 마세요.
 *   📌 변경 시 반드시 BugHerd 티켓 번호와 함께 PR 작성.
 *   📌 회귀 테스트(src/__tests__/searchDictionary.test.js) 통과 필수.
 *   📌 CI(.github/workflows/test.yml)가 자동으로 누락 항목을 차단합니다.
 *
 * ─────────────────────────────────────────────────────────
 *
 * 용도:
 *   카카오 Maps 응답은 한글 전용이므로, 비한국어 UI 에서 주요 랜드마크/
 *   공항/지하철역/호텔/쇼핑몰 이름을 현지 언어로 표기하기 위한 테이블.
 *
 * 짝을 이루는 사전:
 *   - src/i18n/searchAliases.frozen.js (QUERY_ALIASES) — 영문/일/중 → 한글 쿼리 확장 (입력)
 *   - src/i18n/placeNames.js (PLACE_NAMES_MAP, 본 파일)  — 한글 결과 → 다국어 표기 (출력)
 *
 * 키 / 값:
 *   - 키: 카카오 API 가 반환하는 한글 표제어 (`place_name`)
 *   - 값: { en, zh, ja, es } — 미등록 언어는 fallback 으로 한글 표시
 *
 * 클라이언트 컴플레인 이력 (절대 빠뜨리면 안 됨):
 *   #18 (2026-04-29): 일/중/영 입력 시 카카오 검색 결과 0건 — 외국인 사용 불가
 *   #18 코멘트 (2026-05-07): "lotte hotel", "shilla" 등 영문 단독 입력 미동작
 *   추가: 검색 결과 한국어 → 외국어 전환 깜빡임 (정적 사전 hit 율 ↑ 로 해결)
 *
 * ─────────────────────────────────────────────────────────
 */

export const PLACE_NAMES_MAP = {
  // 궁궐
  '경복궁': { en: 'Gyeongbokgung Palace', zh: '景福宫', ja: '景福宮', es: 'Palacio Gyeongbokgung' },
  '창덕궁': { en: 'Changdeokgung Palace', zh: '昌德宫', ja: '昌徳宮', es: 'Palacio Changdeokgung' },
  '덕수궁': { en: 'Deoksugung Palace', zh: '德寿宫', ja: '徳寿宮', es: 'Palacio Deoksugung' },
  '창경궁': { en: 'Changgyeonggung Palace', zh: '昌庆宫', ja: '昌慶宮', es: 'Palacio Changgyeonggung' },
  '경희궁': { en: 'Gyeonghuigung Palace', zh: '庆熙宫', ja: '慶熙宮', es: 'Palacio Gyeonghuigung' },

  // 공항
  '인천국제공항': { en: 'Incheon International Airport', zh: '仁川国际机场', ja: '仁川国際空港', es: 'Aeropuerto Internacional de Incheon' },
  '김포국제공항': { en: 'Gimpo International Airport', zh: '金浦国际机场', ja: '金浦国際空港', es: 'Aeropuerto Internacional de Gimpo' },

  // 주요 역
  '서울역': { en: 'Seoul Station', zh: '首尔站', ja: 'ソウル駅', es: 'Estación de Seúl' },
  '강남역': { en: 'Gangnam Station', zh: '江南站', ja: '江南駅', es: 'Estación de Gangnam' },
  '홍대입구역': { en: 'Hongik University Station', zh: '弘大入口站', ja: '弘大入口駅', es: 'Estación de Hongik Univ.' },
  '명동역': { en: 'Myeongdong Station', zh: '明洞站', ja: '明洞駅', es: 'Estación de Myeongdong' },

  // 관광/쇼핑 랜드마크
  '명동': { en: 'Myeongdong', zh: '明洞', ja: '明洞', es: 'Myeongdong' },
  '강남': { en: 'Gangnam', zh: '江南', ja: '江南', es: 'Gangnam' },
  '홍대': { en: 'Hongdae', zh: '弘大', ja: '弘大', es: 'Hongdae' },
  '이태원': { en: 'Itaewon', zh: '梨泰院', ja: '梨泰院', es: 'Itaewon' },
  '인사동': { en: 'Insadong', zh: '仁寺洞', ja: '仁寺洞', es: 'Insadong' },
  '동대문': { en: 'Dongdaemun', zh: '东大门', ja: '東大門', es: 'Dongdaemun' },
  '남산': { en: 'Namsan', zh: '南山', ja: '南山', es: 'Namsan' },
  'N서울타워': { en: 'N Seoul Tower', zh: 'N首尔塔', ja: 'Nソウルタワー', es: 'Torre N de Seúl' },
  '롯데월드타워': { en: 'Lotte World Tower', zh: '乐天世界塔', ja: 'ロッテワールドタワー', es: 'Torre Lotte World' },
  '롯데월드': { en: 'Lotte World', zh: '乐天世界', ja: 'ロッテワールド', es: 'Lotte World' },
  '코엑스': { en: 'COEX', zh: 'COEX', ja: 'COEX', es: 'COEX' },
  'DMZ': { en: 'DMZ', zh: 'DMZ', ja: 'DMZ', es: 'DMZ' },
  '임진각': { en: 'Imjingak', zh: '临津阁', ja: '臨津閣', es: 'Imjingak' },
  '광화문': { en: 'Gwanghwamun', zh: '光化门', ja: '光化門', es: 'Gwanghwamun' },
  '북촌한옥마을': { en: 'Bukchon Hanok Village', zh: '北村韩屋村', ja: '北村韓屋村', es: 'Aldea Hanok de Bukchon' },
  '남산한옥마을': { en: 'Namsangol Hanok Village', zh: '南山韩屋村', ja: '南山韓屋村', es: 'Aldea Hanok de Namsan' },

  // 면세점/백화점 (주요 3사)
  '신세계면세점': { en: 'Shinsegae Duty Free', zh: '新世界免税店', ja: '新世界免税店', es: 'Duty Free Shinsegae' },
  '롯데면세점': { en: 'Lotte Duty Free', zh: '乐天免税店', ja: 'ロッテ免税店', es: 'Duty Free Lotte' },
  '신라면세점': { en: 'Shilla Duty Free', zh: '新罗免税店', ja: '新羅免税店', es: 'Duty Free Shilla' },
  '신세계백화점': { en: 'Shinsegae Department Store', zh: '新世界百货', ja: '新世界百貨店', es: 'Grandes Almacenes Shinsegae' },
  '롯데백화점': { en: 'Lotte Department Store', zh: '乐天百货', ja: 'ロッテ百貨店', es: 'Grandes Almacenes Lotte' },
  '현대백화점': { en: 'Hyundai Department Store', zh: '现代百货', ja: '現代百貨店', es: 'Grandes Almacenes Hyundai' },
  '갤러리아백화점': { en: 'Galleria Department Store', zh: '加来利亚百货', ja: 'ギャラリア百貨店', es: 'Grandes Almacenes Galleria' },

  // 주요 호텔 (외국인 자주 검색)
  '롯데호텔': { en: 'Lotte Hotel', zh: '乐天酒店', ja: 'ロッテホテル', es: 'Hotel Lotte' },
  '롯데호텔 서울': { en: 'Lotte Hotel Seoul', zh: '乐天酒店首尔', ja: 'ロッテホテルソウル', es: 'Hotel Lotte Seúl' },
  '신라호텔': { en: 'The Shilla Seoul', zh: '新罗酒店', ja: '新羅ホテル', es: 'The Shilla Seoul' },
  '시그니엘 서울': { en: 'Signiel Seoul', zh: '西格尼尔首尔', ja: 'シグニエルソウル', es: 'Signiel Seoul' },
  '시그니엘': { en: 'Signiel', zh: '西格尼尔', ja: 'シグニエル', es: 'Signiel' },
  '조선호텔': { en: 'Josun Hotel', zh: '朝鲜酒店', ja: '朝鮮ホテル', es: 'Hotel Josun' },
  '웨스틴 조선': { en: 'Westin Josun', zh: '威斯汀朝鲜', ja: 'ウェスティン朝鮮', es: 'Westin Josun' },
  '그랜드 하얏트 서울': { en: 'Grand Hyatt Seoul', zh: '首尔君悦酒店', ja: 'グランドハイアットソウル', es: 'Grand Hyatt Seoul' },
  '파크 하얏트 서울': { en: 'Park Hyatt Seoul', zh: '首尔柏悦酒店', ja: 'パーク ハイアット ソウル', es: 'Park Hyatt Seoul' },
  '콘래드 서울': { en: 'Conrad Seoul', zh: '首尔康莱德', ja: 'コンラッドソウル', es: 'Conrad Seoul' },
  'JW 메리어트 서울': { en: 'JW Marriott Seoul', zh: '首尔JW万豪', ja: 'JWマリオット ソウル', es: 'JW Marriott Seoul' },
  '쉐라톤 서울': { en: 'Sheraton Seoul', zh: '首尔喜来登', ja: 'シェラトンソウル', es: 'Sheraton Seoul' },
  '워커힐': { en: 'Walkerhill', zh: '华克山庄', ja: 'ウォーカーヒル', es: 'Walkerhill' },
  '그랜드 워커힐': { en: 'Grand Walkerhill Seoul', zh: '首尔华克山庄', ja: 'グランドウォーカーヒル', es: 'Grand Walkerhill' },
  '인터컨티넨탈': { en: 'InterContinental', zh: '洲际酒店', ja: 'インターコンチネンタル', es: 'InterContinental' },
  '포시즌스 호텔 서울': { en: 'Four Seasons Hotel Seoul', zh: '首尔四季酒店', ja: 'フォーシーズンズホテルソウル', es: 'Four Seasons Hotel Seoul' },
  '페어몬트 앰배서더 서울': { en: 'Fairmont Ambassador Seoul', zh: '首尔费尔蒙', ja: 'フェアモントアンバサダーソウル', es: 'Fairmont Ambassador Seoul' },

  // 주요 쇼핑몰
  '롯데월드몰': { en: 'Lotte World Mall', zh: '乐天世界购物中心', ja: 'ロッテワールドモール', es: 'Lotte World Mall' },
  '스타필드': { en: 'Starfield', zh: '星空购物中心', ja: 'スターフィールド', es: 'Starfield' },
  '더현대 서울': { en: 'The Hyundai Seoul', zh: '现代百货首尔店', ja: 'ザ・ヒュンダイソウル', es: 'The Hyundai Seoul' },
  '타임스퀘어': { en: 'Times Square', zh: '时代广场', ja: 'タイムズスクエア', es: 'Times Square' },
  '코엑스몰': { en: 'COEX Mall', zh: 'COEX购物中心', ja: 'COEXモール', es: 'COEX Mall' },
  'IFC몰': { en: 'IFC Mall', zh: 'IFC购物中心', ja: 'IFCモール', es: 'IFC Mall' },
  '동대문디자인플라자': { en: 'Dongdaemun Design Plaza (DDP)', zh: '东大门设计广场', ja: '東大門デザインプラザ', es: 'Dongdaemun Design Plaza' },
  'DDP': { en: 'DDP', zh: 'DDP', ja: 'DDP', es: 'DDP' },

  // 관광지/명소
  '익선동': { en: 'Ikseon-dong', zh: '益善洞', ja: '益善洞', es: 'Ikseon-dong' },
  '서울숲': { en: 'Seoul Forest', zh: '首尔林', ja: 'ソウルの森', es: 'Bosque de Seúl' },
  '청계천': { en: 'Cheonggyecheon', zh: '清溪川', ja: '清渓川', es: 'Cheonggyecheon' },
  '광장시장': { en: 'Gwangjang Market', zh: '广藏市场', ja: '広蔵市場', es: 'Mercado Gwangjang' },
  '남대문시장': { en: 'Namdaemun Market', zh: '南大门市场', ja: '南大門市場', es: 'Mercado Namdaemun' },
  '가로수길': { en: 'Garosu-gil', zh: '林荫路', ja: '街路樹通り', es: 'Garosu-gil' },
  '한강공원': { en: 'Hangang Park', zh: '汉江公园', ja: '漢江公園', es: 'Parque del Río Han' },
  '한강': { en: 'Han River', zh: '汉江', ja: '漢江', es: 'Río Han' },
  '북한산': { en: 'Bukhansan', zh: '北汉山', ja: '北漢山', es: 'Bukhansan' },
  '경리단길': { en: 'Gyeongnidan-gil', zh: '经理团路', ja: '経理団通り', es: 'Gyeongnidan-gil' },
  '석촌호수': { en: 'Seokchon Lake', zh: '石村湖', ja: '石村湖', es: 'Lago Seokchon' },

  // 주요 역 (확장)
  '용산역': { en: 'Yongsan Station', zh: '龙山站', ja: '龍山駅', es: 'Estación de Yongsan' },
  '잠실역': { en: 'Jamsil Station', zh: '蚕室站', ja: '蚕室駅', es: 'Estación de Jamsil' },
  '왕십리역': { en: 'Wangsimni Station', zh: '往十里站', ja: '往十里駅', es: 'Estación de Wangsimni' },
  '신촌역': { en: 'Sinchon Station', zh: '新村站', ja: '新村駅', es: 'Estación de Sinchon' },
  '이태원역': { en: 'Itaewon Station', zh: '梨泰院站', ja: '梨泰院駅', es: 'Estación de Itaewon' },

  // 행정/지역
  '잠실': { en: 'Jamsil', zh: '蚕室', ja: '蚕室', es: 'Jamsil' },
  '용산': { en: 'Yongsan', zh: '龙山', ja: '龍山', es: 'Yongsan' },
  '신촌': { en: 'Sinchon', zh: '新村', ja: '新村', es: 'Sinchon' },
  '서초': { en: 'Seocho', zh: '瑞草', ja: '瑞草', es: 'Seocho' },
  '송파': { en: 'Songpa', zh: '松坡', ja: '松坡', es: 'Songpa' },
  '여의도': { en: 'Yeouido', zh: '汝矣岛', ja: '汝矣島', es: 'Yeouido' },
};

/**
 * 한글 장소명을 현재 UI 언어로 번역.
 * 카카오 응답 name은 "롯데월드타워 서울스카이" 같이 접미 포함 케이스가 많아
 * 전체 일치뿐 아니라 **startsWith** 도 시도.
 *
 * @param {string} koName - 카카오 응답 `place_name` (한글)
 * @param {string} beLang - 'ko' | 'en' | 'zh' | 'ja' | 'es'
 * @returns 번역된 장소명 (없으면 원본 한글)
 */
export function translatePlaceName(koName, beLang) {
  if (!koName || beLang === 'ko') return koName;
  const direct = PLACE_NAMES_MAP[koName];
  if (direct && direct[beLang]) return direct[beLang];

  // 접미 포함 케이스: "롯데월드타워 서울스카이" → "롯데월드타워"
  for (const key of Object.keys(PLACE_NAMES_MAP)) {
    if (koName.startsWith(key)) {
      const translated = PLACE_NAMES_MAP[key][beLang];
      if (translated) {
        const suffix = koName.slice(key.length).trim();
        return suffix ? `${translated} ${suffix}` : translated;
      }
    }
  }
  return koName;
}
